const WP_API_BASE =
  process.env.REACT_APP_WP_API_URL ||
  "https://stg.leaps-inc.com/cms-admin/?rest_route=";

/**
 * WordPress REST API からデータを取得する
 * @param {string} endpoint - APIエンドポイント（例: "/wp/v2/posts"）
 * @param {object} params - クエリパラメータ
 */
export async function fetchWP(endpoint, params = {}) {
  const qs = Object.entries(params)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
  const sep = WP_API_BASE.includes("?") ? "&" : "?";
  const fetchUrl = WP_API_BASE + endpoint + (qs ? sep + qs : "");

  const res = await fetch(fetchUrl);
  if (!res.ok) {
    throw new Error(`WP API error: ${res.status}`);
  }
  return res.json();
}

/**
 * ページネーション付きで WordPress REST API からデータを取得する
 * @returns {Promise<{data: any[], totalPages: number, total: number}>}
 */
export async function fetchWPPaginated(endpoint, params = {}) {
  const qs = Object.entries(params)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
  const sep = WP_API_BASE.includes("?") ? "&" : "?";
  const fetchUrl = WP_API_BASE + endpoint + (qs ? sep + qs : "");

  const res = await fetch(fetchUrl);
  if (!res.ok) {
    throw new Error(`WP API error: ${res.status}`);
  }
  const data = await res.json();
  const totalPages = Number(res.headers.get("X-WP-TotalPages")) || 1;
  const total = Number(res.headers.get("X-WP-Total")) || data.length;
  return { data, totalPages, total };
}

/** 実績一覧を取得 */
/**
 * メディア記事（カスタム投稿タイプ media）を取得する。
 *
 * rest_base は 'media-articles'。CPT名の 'media' をそのまま使うと
 * コアの添付ファイル（/wp/v2/media）と衝突するため。
 */
export function fetchMediaArticles(params = {}) {
  return fetchWP("/wp/v2/media-articles", params);
}

export function fetchCases(params = {}) {
  return fetchWP("/wp/v2/cases", {
    per_page: 12,
    _embed: "",
    ...params,
  });
}

/** News（投稿）一覧を取得 */
export function fetchNews(params = {}) {
  return fetchWP("/wp/v2/posts", {
    per_page: 5,
    _embed: "",
    ...params,
  });
}

/** News一覧をページネーション付きで取得 */
export function fetchNewsPaginated(params = {}) {
  return fetchWPPaginated("/wp/v2/posts", {
    per_page: 12,
    _embed: "",
    ...params,
  });
}

/** 実績一覧をページネーション付きで取得 */
export function fetchCasesPaginated(params = {}) {
  return fetchWPPaginated("/wp/v2/cases", {
    per_page: 12,
    _embed: "",
    ...params,
  });
}

/** カテゴリ一覧を取得 */
export function fetchCategories() {
  return fetchWP("/wp/v2/categories");
}

/** 業種タグ一覧を取得 */
export function fetchIndustries() {
  return fetchWP("/wp/v2/industry");
}

/** サービスタグ一覧を取得 */
export function fetchServiceTags() {
  return fetchWP("/wp/v2/service-tag");
}
